import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "BMI",
    isNumber: true,
    isSum: true,
  },
];

const groupOrders = {
  教育: {
    不識字: 0,
    國小: 1,
    國中: 2,
    高中: 3,
    大專院校: 4,
    研究所以上: 5,
    其他: 6,
    "-": 7,
  },
};

export const EducationLevelToBMI = {
  label: "教育程度 vs BMI",
  key: "EducationLevelToBMI",
  path: "BMI/EducationLevelToBMI",
  api: "TCS_V_BMIItemsV",
  render: (options) => <Diagram.BMI.EducationLevelToBMI {...options} />,
  isPercent: true,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "教育",
      field: "教育",
      header: "",
    },
  ],
  groupOrders,
  levelColumns,
  columns: [],
};
